export {
  Table,
  TableBody as Body,
  TableCell as Cell,
  TableContainer as Container,
  TableHead as Head,
  TableRow as Row,
  TableSortLabel as SortLabel,
} from '@material-ui/core';
